import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { WhiteBlankImageView } from './WhiteBlankImageView';
import { cleanConditionSyntax } from '../utils/templateParser';

export const WhiteBlankImageBlock = Node.create({
    name: 'whiteBlankImage',
    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,

    addAttributes() {
        return {
            width: {
                default: '1.0',
                parseHTML: element => element.getAttribute('data-width') || '1.0',
                renderHTML: attributes => ({ 'data-width': attributes.width }),
            },
            height: {
                default: '1.0',
                parseHTML: element => element.getAttribute('data-height') || '1.0',
                renderHTML: attributes => ({ 'data-height': attributes.height }),
            },
            filename: {
                default: 'signature.png',
                parseHTML: element => element.getAttribute('data-filename') || 'signature.png',
                renderHTML: attributes => ({ 'data-filename': attributes.filename }),
            },
            align: {
                default: 'left',
                parseHTML: element => element.getAttribute('data-align') || 'left',
                renderHTML: attributes => ({ 'data-align': attributes.align || 'left' }),
            },
            condition: {
                default: '',
                parseHTML: element => element.getAttribute('data-condition') || '',
                renderHTML: attributes => attributes.condition ? ({ 'data-condition': attributes.condition }) : {},
            },
            conditionData: {
                default: '',
                parseHTML: element => element.getAttribute('data-condition-data') || '',
                renderHTML: attributes => attributes.conditionData ? ({ 'data-condition-data': attributes.conditionData }) : {},
            },
            ruleId: {
                default: '',
                parseHTML: element => element.getAttribute('data-rule-id') || '',
                renderHTML: attributes => attributes.ruleId ? ({ 'data-rule-id': attributes.ruleId }) : {},
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-type="white-blank-image"]',
                getAttrs: el => {
                    const cond = el.getAttribute('data-condition') || '';
                    const condData = el.getAttribute('data-condition-data') || '';
                    return {
                        width: el.getAttribute('data-width') || '1.0',
                        height: el.getAttribute('data-height') || '1.0',
                        filename: el.getAttribute('data-filename') || 'signature.png',
                        align: el.getAttribute('data-align') || 'left',
                        condition: cleanConditionSyntax(cond, condData),
                        conditionData: condData,
                        ruleId: el.getAttribute('data-rule-id') || '',
                    };
                },
            },
            {
                tag: 'div[data-type="signature-box"]',
                getAttrs: el => {
                    const cond = el.getAttribute('data-condition') || '';
                    const condData = el.getAttribute('data-condition-data') || '';
                    return {
                        width: el.getAttribute('data-width') || '1.0',
                        height: el.getAttribute('data-height') || '1.0',
                        filename: el.getAttribute('data-filename') || 'signature.png',
                        align: el.getAttribute('data-align') || 'left',
                        condition: cleanConditionSyntax(cond, condData),
                        conditionData: condData,
                        ruleId: el.getAttribute('data-rule-id') || '',
                    };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['div', mergeAttributes({
            'data-type': 'white-blank-image',
            class: 'white-blank-image-block',
        }, HTMLAttributes)];
    },

    addNodeView() {
        return ReactNodeViewRenderer(WhiteBlankImageView);
    },

    addCommands() {
        return {
            setWhiteBlankImage: (options = {}) => ({ chain }) => {
                return chain().insertContent({
                    type: this.name,
                    attrs: {
                        width: options.width || '1.0',
                        height: options.height || '1.0',
                        filename: options.filename || 'signature.png',
                        align: options.align || 'left',
                        condition: options.condition || '',
                        conditionData: options.conditionData || '',
                        ruleId: options.ruleId || '',
                    }
                }).run();
            },
        };
    },
});
